/**
* @Author: zachalam
* @Date:   2017-01-19T16:11:24-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-23T16:59:05-08:00
*/

import jwtDecode from 'jwt-decode';
import { tsNow } from '../common';

let initialState = {
  isAuthenticated: false,
  jwToken: '',
  jwtUnixExpiration: '',
  //refreshingToken: false,
  freshTokenPromise: null,
  requestList: [{loc: null, time: 0}]

}

const auth = (state = initialState, action) => {
  //let {data} = action.payload;
  switch(action.type) {
    case 'LOGIN_USER':
    //console.log("user logged in")
    let jwToken = action.payload.token;
    // parse jwt for expiration timeStamp
    let jwtUnixExpiration = jwtDecode(jwToken).exp;
    // save everything.
    return {
      ...state,
      isAuthenticated: true,
      jwtUnixExpiration,
      jwToken
    }
    case 'LOGOUT_USER':
    //console.log("user logged out");
    // these next cases are for making sure we dont attempt to refresh mutliple JWT's.
    case 'REFRESHING_TOKEN':
      return {
        ...state,
        freshTokenPromise: action.payload
      }
    case 'DONE_REFRESHING_TOKEN':
      return {
        ...state,
        freshTokenPromise: null,
      }

    case 'REMOVE_STALE_HTTP_REQUESTS':
      // remove stale requests (> 1000ms old)
      if(!state.requestList)
        return {
          ...state,
          requestList: []
        }
      else
        return {
          ...state,
          requestList: state.requestList.filter(function(a){return (a.time+1000 > tsNow()) })
        }
    case 'STORE_HTTP_REQUEST':
      return {
        ...state,
        requestList: [ {loc: action.payload.toLowerCase(), time: tsNow()}, ...state.requestList ]
      }
    case 'REMOVE_HTTP_REQUEST':
      return {
        ...state,
        requestList: state.requestList.filter(function(a){ return a.loc !== action.payload})
      }

    default:
      return state

  }
}

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth.js